import { IPreference } from './userProfile';

export class UserUpdate {
  name: string = '';
  pinHash?: string;
  preference?: IPreference;
}
